import React, { Fragment, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  Container,
  Row,
  Col,
  TabPane,
  TabContent,
  Nav,
  NavItem,
  NavLink,
  InputGroup,
  CustomInput,
} from 'reactstrap';
import classnames from 'classnames';
import { Title, LoadingCard, PageHeader } from '../Shared';
import { eventActions, leaderboardActions } from '../_actions';
import isEmpty from 'lodash/isEmpty';
import { date } from '../_helpers';
import { LeaderBoardPane } from '../Locations';

const EventPane = (props) => {
  return (
    <>
      {props.data && !isEmpty(props.data.events) ? (
        <>
          <EventSelect events={props.data.events} />
        </>
      ) : (
        <div className="no-times text-center">No events found</div>
      )}
    </>
  );
};

function Events(props) {
  const [tab, setTab] = useState('upcoming');
  const { upcoming, past, getUpcoming, getPast, loading } = props;

  useEffect(() => {
    getUpcoming();
    getPast();
  }, [getUpcoming, getPast]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const eventId = params.get('eventId');
    if (eventId && upcoming && !isEmpty(upcoming)) {
      const intEventId = parseInt(eventId);
      const future = upcoming.events.find((u) => u.id === intEventId);
      if (!future) {
        setTab('past');
      }
    }
  }, [upcoming]);

  return (
    <Fragment>
      <Title text="Upcoming Events" />
      <PageHeader className="default">
        <Row>
          <Col sm={12}>
            <h2 className="orange-title text-center">Events</h2>
          </Col>
        </Row>
      </PageHeader>
      <Container className="mt-4 pl-4 pr-4">
        {loading && (
          <Row>
            <LoadingCard />
          </Row>
        )}
        <Nav className="rounded-tabs" fill tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: tab === 'upcoming' })}
              onClick={() => setTab('upcoming')}
            >
              UPCOMING EVENTS
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: tab === 'past' })}
              onClick={() => setTab('past')}
            >
              CURRENT AND PAST EVENTS
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={tab}>
          <TabPane tabId="upcoming">
            <EventPane data={upcoming} />
          </TabPane>
          <TabPane tabId="past">
            <EventPane data={past} />
          </TabPane>
        </TabContent>
      </Container>
    </Fragment>
  );
}

function mapState(state) {
  const { upcoming, past, loading } = state.event;

  return { upcoming, past, loading };
}

const mapDispatch = {
  getUpcoming: eventActions.getUpcoming,
  getPast: eventActions.getPast,
  filter: eventActions.filter,
};
const connectedEvents = connect(mapState, mapDispatch)(Events);
export { connectedEvents as Events };

function EventSelect({ events }) {
  const [eventId, setEventId] = useState(0);
  const [displayable, setDisplayable] = useState();
  const dispatch = useDispatch();

  const [infoTab, setInfoTab] = useState('casual');

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const eventId = params.get('eventId');
      if (eventId) {
        setEventId(parseInt(eventId));
      }
    } catch {}
  }, []);

  useEffect(() => {
    if (eventId) {
      const toDisplay = events.find((e) => e.id === eventId);
      if (toDisplay) {
        dispatch(leaderboardActions.forEvent(toDisplay.id));
        setDisplayable(toDisplay);
      }
    } else {
      setDisplayable(undefined);
    }
  }, [dispatch, eventId, events]);
  const lb = useSelector((s) => s.leaderboard);
  const lbById = displayable && lb[displayable.id];

  return (
    <>
      <InputGroup>
        <CustomInput
          className="rounded-select"
          type="select"
          id={'eventselect'}
          name="eventId"
          onChange={(e) => setEventId(parseInt(e.target.value))}
          value={eventId}
          required
        >
          <option value="0">Select an Event</option>
          {events.map((ev) => (
            <option key={ev.id} value={ev.id}>
              {ev.name}, {ev.location.name}, {date.getShortDate(ev.startTime)}
            </option>
          ))}
        </CustomInput>
      </InputGroup>
      {displayable && (
        <Container>
          <Row className="mt-4">
            <h4>
              {displayable.name} at {displayable.location.name}
            </h4>
          </Row>
          <Row>
            <h6>Held on {date.getShortDate(displayable.startTime)}</h6>
          </Row>
          <Row>
            <Container
              className="mt-4 pb-4 px-0"
              style={{ backgroundColor: '#fff' }}
            >
              <Nav className="rounded-tabs" fill tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: infoTab === 'casual' })}
                    onClick={() => setInfoTab('casual')}
                  >
                    CASUAL TIMES
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: infoTab === 'event' })}
                    onClick={() => setInfoTab('event')}
                  >
                    COMPETITION TIMES
                  </NavLink>
                </NavItem>
              </Nav>
              {lbById && (
                <TabContent activeTab={infoTab}>
                  <TabPane tabId="casual">
                    <LeaderBoardPane data={lbById.unofficial || []} />
                  </TabPane>
                  <TabPane tabId="event">
                    <LeaderBoardPane data={lbById.official || []} />
                  </TabPane>
                </TabContent>
              )}
            </Container>
          </Row>
        </Container>
      )}
    </>
  );
}
